import React from "react";
import SignupThanks from "@components/templates/SignupThanks";

export default function SignupThanksScreen() {
  return <SignupThanks />;
}
